import React from 'react';
import SlideUpDownNav from './../../inc/SlideUpDownNav';

import SwiperCore, {Navigation, Autoplay, A11y, EffectFade } from 'swiper';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/swiper-bundle.css';

import d1 from './../../../assets/img/projects/marmalade/d1.jpg';
import d2 from './../../../assets/img/projects/marmalade/d2.png';
import d3 from './../../../assets/img/projects/marmalade/d3.png';
import d4 from './../../../assets/img/projects/marmalade/d4.png';
import d5 from './../../../assets/img/projects/marmalade/d5.png';
import d6 from './../../../assets/img/projects/marmalade/d6.png';


class DrawingSlider extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <section className="mole__project--dcarousel mb-0"> 
                <div className="main-container">
                    <div className="inner-container">
                    <Swiper 
                         autoplay
                         effect="fade"
                         loop="false" 
                         speed={800}
                         navigation={{
                             prevEl: '.swiper-hero--prev',
                             nextEl: '.swiper-hero--next',
                         }}
                         pagination={{
                             el: ".swiper-pagination",
                             type: "fraction",
                         }}
                    >
                    
                        
                        {/* slides */}
                        <SwiperSlide>
                            <div className="grid">
                                <article className="desc">
                                    <h4 className="font-md">Cohesion and choice</h4>
                                    <p>As a custom-build development, each
                                    household were able to select from a
                                    number of ‘shell’ house or apartment
                                    types, flexibly deployed across the site
                                    on a ‘first come first serve’ basis.</p>
                                </article>
                                <figure className>
                                    <img src={d1} alt="ProjctTitle" title="ProjctTitle"/>
                                </figure>
                            </div>
                        </SwiperSlide>


                        <SwiperSlide>
                            <div className="grid">
                                <article className="desc">
                                    <h4 className="font-md">Cohesion and choice</h4>
                                    <p>As a custom-build development, each
                                    household were able to select from a
                                    number of ‘shell’ house or apartment
                                    types, flexibly deployed across the site
                                    on a ‘first come first serve’ basis.</p>
                                </article>
                                <figure className>
                                    <img src={d2} alt="ProjctTitle" title="ProjctTitle"/>
                                </figure>
                            </div>
                        </SwiperSlide>


                        <SwiperSlide>
                            <div className="grid">
                                <article className="desc">
                                   <h4 className="font-md">Custom Build Strategy</h4>
                                   <p>Using a selection of standard
                                    floorplans, kitchen and bathroom
                                    fittings, and one of four external brick
                                    specifications, homes were tailored to
                                    individual requirements without the
                                    risks or complexity of self-build.</p>
                                </article>
                                <figure>
                                    <img src={d3} alt="ProjctTitle" title="ProjctTitle"/>
                                </figure>
                            </div>
                        </SwiperSlide>


                        <SwiperSlide>
                            <div className="grid">
                                <article className="desc">
                                   <h4 className="font-md">Tailored to Individual Requirements</h4>
                                   <p>This unique custom-build strategy
                                    offered choice to residents without
                                    the risks or complexity of self-build,
                                    and certainty of project cost from
                                    the outset.</p>
                                </article>
                                <figure>
                                    <img src={d4} alt="ProjctTitle" title="ProjctTitle"/>
                                </figure>
                            </div>
                        </SwiperSlide>


                        <SwiperSlide>
                            <div className="grid">
                                <article className="desc">
                                    <h4 className="font-md">Cohesion and choice</h4>
                                    <p>As a custom-build development, each
                                    household were able to select from a
                                    number of ‘shell’ house or apartment
                                    types, flexibly deployed across the site
                                    on a ‘first come first serve’ basis.</p>
                                </article>
                                <figure>
                                    <img src={d5} alt="ProjctTitle" title="ProjctTitle"/>
                                </figure>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide>
                            <div className="grid">
                                <article className="desc">
                                    <h4 className="font-md">Cohesion and choice</h4>
                                    <p>As a custom-build development, each
                                    household were able to select from a
                                    number of ‘shell’ house or apartment
                                    types, flexibly deployed across the site
                                    on a ‘first come first serve’ basis.</p>
                                </article>
                                <figure>
                                    <img src={d6} alt="ProjctTitle" title="ProjctTitle"/>
                                </figure>
                            </div>
                        </SwiperSlide>

                            <div className="text-right">
                                <div className="swiper--navs">
                                    <div className="swiper-pagination"></div>

                                    <div className="swiper-nav">
                                        <span className="swiper-hero--prev">
                                        <svg version="1.1" x="0px" y="0px" viewBox="0 0 35.7 60">
                                            <polygon points="4.7,34.1 5.2,34.6 5.2,34.6 15.8,45.3 30.5,60 35.7,54.8 21,40.1 10.3,29.5 20.4,19.3 34.6,5.2 29.5,0  15.3,14.2 5.2,24.3 5.2,24.3 4.8,24.6 0,29.5 0,29.5 "/>
                                        </svg>
                                        </span>

                                        <span className="swiper-hero--next">
                                        <svg version="1.1" x="0px" y="0px" viewBox="0 0 35.7 60">
                                            <polygon points="35.7,29.5 35.7,29.5 30.9,24.6 30.5,24.3 30.5,24.3 20.4,14.2 6.2,0 1.1,5.2 15.3,19.3 25.4,29.5 14.7,40.1 0,54.8 5.2,60 19.9,45.3 30.5,34.6 30.5,34.6 31,34.1 "/>
                                        </svg>
                                        </span>
                                    </div>
                                </div>
                           </div>
                    </Swiper>  
                    </div>
                </div>
            </section>
        );
    }
}
export default DrawingSlider;



// WEBPACK FOOTER //
// ./src/components/Projects/Details/DrawingSlider.js